import ISvgProps from '../SvgLoader/ISvgProps';
import { FC } from 'react';

export const NotTheOriginalPayee: FC<ISvgProps> = ({ primaryColor = '#535763' }) => {
	return (
		<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="29.5" cy="20.3569" r="8.6" stroke="#5977EB" strokeWidth="1.8" />
			<path
				d="M45.9586 45.7718V48.1802C45.9586 48.2152 45.9302 48.2435 45.8952 48.2435H14.1047C14.0697 48.2435 14.0414 48.2152 14.0414 48.1802V45.7718C14.0414 36.9581 21.1863 29.8132 30 29.8132C38.8137 29.8132 45.9586 36.9581 45.9586 45.7718Z"
				stroke="#5977EB"
				strokeWidth="1.8"
			/>
			<ellipse cx="45.5" cy="48" rx="7.5" ry="8" fill="#F5F5F5" />
			<path
				d="M45.555 56.11C40.8301 56.11 37 52.2799 37 47.555C37 42.8301 40.8301 39 45.555 39C50.2799 39 54.11 42.8301 54.11 47.555C54.11 52.2799 50.2799 56.11 45.555 56.11ZM45.555 46.3453L43.1356 43.9251L41.9251 45.1356L44.3453 47.555L41.9251 49.9744L43.1356 51.1849L45.555 48.7647L47.9744 51.1849L49.1849 49.9744L46.7647 47.555L49.1849 45.1356L47.9744 43.9251L45.555 46.3453Z"
				fill="#F77430"
			/>
		</svg>
	);
};
